import { Component } from '@angular/core';

@Component({
  selector: 'app-alert-temp-pass',
  templateUrl: './alert-temp-pass.component.html',
  styleUrl: './alert-temp-pass.component.scss'
})
export class AlertTempPassComponent {

}
